// extracted by mini-css-extract-plugin
module.exports = {"title":"HumidityCard_title__2wiZI","main":"HumidityCard_main__14Sy8","value":"HumidityCard_value__1fKli"};